/**
 * 指数1：安卓：内存小于2G的设备
 * 指数2：安卓：内存小于3G的设备，或者CPU为晓龙4系列或660以下（如625，630，631，不包括660），iPhone5s
 * 指数3：安卓：内存小于6G的设备，iPhone 6/7
 * 指数4：其他
 */
const INDEX_UNKNOWN = 0;
const INDEX_1 = 1;
const INDEX_2 = 2;
const INDEX_3 = 3;
const INDEX_4 = 4;
export { INDEX_UNKNOWN, INDEX_1, INDEX_2, INDEX_3, INDEX_4 };
